import { trackingPixelPath } from "@rezonence/analytics";

export const trackingUrlPath = trackingPixelPath.replace("/", "");

